@if (!disableHeader) {
  <ion-header>
    <ion-toolbar >
      <ion-buttons slot="start">
        <ion-menu-button (click)="closePopup()"></ion-menu-button>
      </ion-buttons>
      <ion-title style="font-size: 13px !important;">
        <div class="titleBar">
          <ion-title style="font-size: 13px; text-align: left;" [ngClass]="{'adjustedTitleFont': setting.configuration.uIoptions?.homePageOption == 10}">{{ title  | translate }}</ion-title>
          <!--{{ title  | translate }}-->
          @if (NotificationService.showNotificationBell) {
            <ion-buttons class="notificationbutton" (click)="this.NotificationBellService.openNotificationBell(this.AllNotifications)">
              <div class="bellimgContainer">
                <!--<fa-icon icon="bell" id="bellsize"></fa-icon>-->
                <fa-icon [icon]="bellIcon" id="bellsize"></fa-icon>
                <!--<app-app-icon [icon]="bellIcon" id="bellsize"></app-app-icon>-->
                <!--<img class="bellsize" src="../../../../assets/icon/notification/bell.png" alt="">-->
                @if (this.valideNotification > 0) {
                  <div class="notificationCircle">
                    <p>{{this.valideNotification}}</p>
                  </div>
                }
              </div>
            </ion-buttons>
          }
        </div>
      </ion-title>
    </ion-toolbar>
  </ion-header>
}
<ion-content class="content-theme-one" style="overscroll-behavior: contain;">
  @if ((mobile && !setting.navigationSetting) && setting.configuration.uIoptions) {
    <app-undocked-navigation-bar style="position: relative; z-index: 10;" [disabledOption]="title"></app-undocked-navigation-bar>
  }

  <!--new, non-paginated page-->
  <!--
  <div [ngClass]="{ 'content-push-up': isPopup }">
    @for (order of orders; track order) {
      <ion-card >
        <a routerDirection="root" style="text-decoration: none;">
          <ion-item>
            <ion-icon [name]="(order.isShipping) ? 'cube' : (order.isDelivery) ? 'car' : 'basket'" slot="start" style="margin-inline-end: 10px;"></ion-icon>
            <ion-label id="order-info">#{{order.orderNumber}} {{order.storeName}}</ion-label>
            @if (order.storeAllowSales) {
              <button (click)="reOrder(order)" class="reorder">{{'General.ReOrder' | translate}}</button>
            }
            <button (click)="detail(order.orderId, order.isShipping)" class="details">{{'General.Details' | translate}}</button>
          </ion-item>
        </a>
      </ion-card>
    }
  </div>
  -->

  <div [ngClass]="{ 'content-push-up': isPopup }">

    @for (order of paginatedOrders; track order) {
      <ion-card>
        <a routerDirection="root" style="text-decoration: none;">
          <ion-item>
            <ion-icon
              [name]="(order.isShipping) ? 'cube' : (order.isDelivery) ? 'car' : 'basket'"
              slot="start"
              style="margin-inline-end: 10px;">
            </ion-icon>

            <ion-label id="order-info">
              #{{order.orderNumber}} {{order.storeName}}
            </ion-label>

            @if (order.storeAllowSales) {
              <button (click)="reOrder(order)" class="reorder">
                {{'General.ReOrder' | translate}}
              </button>
            }

            <button
              (click)="detail(order.orderId, order.isShipping)"
              class="details">
              {{'General.Details' | translate}}
            </button>
          </ion-item>
        </a>
      </ion-card>
    }

  </div>

  <mat-paginator
    [style.margin-bottom]="(mobile && !setting.navigationSetting) && setting.configuration.uIoptions ? '60px' : '0px'"
    [length]="orders.length"
    [pageSize]="15"
    [pageSizeOptions]="[15, 25, 50]"
    (page)="onPageChange($event)"
    showFirstLastButtons>
  </mat-paginator>




  <!--old code-->
  <!-- <div  *ngIf="change" class="modal-new-cart">
  <div class="container-warning">
    <div class="new-order">{{'Confirm.Continue' | translate}}</div>
    <p class="para">{{'Confirm.Para' | translate}}</p>
    <div class="buttons">
      <button  class="btns">{{'Confirm.Yes' | translate}}</button><button class="btns"  id="no">{{'Confirm.No' | translate}}</button>
    </div>
  </div>
</div> -->
</ion-content>
